import {styled} from "@reside/ui";
import {Layout, LayoutContent} from "../../atoms/admin-layout";

export const FullWidthDashboardHeader = styled.div`
  // The header is positioned 'over' the grid to prevent dropdowns/popups from the grid to overflow on top of it
  background: ${({theme}) => theme.color.darkBlue5};
  z-index: 997;
  padding: 25px ${({theme}) => theme.space[7]}px 14px
    ${({theme}) => theme.space[7]}px;

  @media (max-width: 1170px) {
    padding-left: 15px;
    padding-right: 15px;
  }

  @media (max-width: 768px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;
export const DashboardLayout = styled(Layout)`
  min-height: 100vh;
`;
export const FullWidthDashboardLayoutContent = styled(LayoutContent)`
  flex-grow: 1;
  max-width: none;
  padding-top: 0 !important;
  padding-left: ${({theme}) => theme.space[7]}px;
  padding-right: ${({theme}) => theme.space[7]}px;
`;

export const ListTileViewSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    padding: 5px 3px;
    cursor: pointer;
    background-color: ${({theme}) => theme.color.darkBlue100}10;
    border-radius: 4px;
    transition: background-color 0.1s ease-in-out;

    &:hover {
      background-color: ${({theme}) => theme.color.darkBlue100}30;
    }

    &.active-view {
      background-color: ${({theme}) => theme.color.darkBlue100}30;
    }
  }
`;

export const LoadMoreWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: fit-content;
  text-align: center;
  margin-top: ${({theme}) => theme.space[3]}px;
`;
